import { useTranslation } from 'react-i18next';

interface TDK {
  title: string;
  description: string;
  keywords: string;
}

export const useFeedTdk = (category: string): TDK => {
  const { t } = useTranslation();

  if (category === '12') {
    return {
      title: t('category_food_title'),
      description: t('category_food_desc'),
      keywords: t('category_food_keyword'),
    };
  }

  if (category === '19') {
    return {
      title: t('category_lifestyle_title'),
      description: t('category_lifestyle_desc'),
      keywords: t('category_lifestyle_keyword'),
    };
  }

  if (category === '569') {
    return {
      title: t('category_beauty_title'),
      description: t('category_beauty_desc'),
      keywords: t('category_beauty_keyword'),
    };
  }

  if (category === '570') {
    return {
      title: t('category_fashion_title'),
      description: t('category_fashion_desc'),
      keywords: t('category_fashion_keyword'),
    };
  }

  if (category === '20') {
    return {
      title: t('category_travel_title'),
      description: t('category_travel_desc'),
      keywords: t('category_travel_keyword'),
    };
  }

  if (category === '37') {
    return {
      title: t('category_pet_title'),
      description: t('category_pet_desc'),
      keywords: t('category_pet_keyword'),
    };
  }

  return {
    title: t('category_recommend_title'),
    description: t('category_recommend_desc'),
    keywords: t('category_recommend_keyword'),
  };
};
